import { AppPresence } from "@closerplatform/spinner-openapi";
import { FormState, FieldState } from "formstate";

export type NewAdviser = FormState<{
  email: FieldState<string>;
  firstName: FieldState<string>;
  lastName: FieldState<string>;
}>;

export type InviteAdvisersForm = FormState<NewAdviser[]>;

export type ExistingAdviserFormFields = {
  id: FieldState<string>;
  email: FieldState<string>;
  firstName: FieldState<string>;
  lastName: FieldState<string>;
  isActive: FieldState<boolean>;
  avatarToken: FieldState<string>;
  roleId: FieldState<string>;
  tagIds: FieldState<string[]>;
  tagGroupIds: FieldState<string[]>;
  agentGroupIds: FieldState<string[]>;
  presence: FieldState<AppPresence>;
  validFrom: FieldState<number | undefined>;
  validTo: FieldState<number | undefined>;
  autoAssignedLimit: FieldState<number | undefined>;
};
export type ExistingAdviserForm = FormState<ExistingAdviserFormFields>;

export const activeAdviserFilterId = "ActiveAdviserFilter";
export const inactiveAdviserFilterId = "InactiveAdviserFilter";
